export default {"src":"/_next/static/media/backgroundImageExample.466e7fe8.svg","height":353,"width":1120,"blurWidth":0,"blurHeight":0};